import cx from "clsx";
import { useRouter } from "next/router";
import React from "react";
import { MdSearch } from "react-icons/md";

import ButtonOnNavbar from "../../../../../NavbarV2/components/ButtonOnNavbar";

import styles from "./index.module.scss";

import { useBusyCount } from "@/modules/common-hooks/useBusyCount";
import { InlineError } from "@/modules/form-field/errors";
import { useModalTrigger$ModalPrompt } from "@/modules/kreate-modals/modals/ModalPrompt/hooks";
import { getLinkToPageExploreAssets } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function ButtonSearch({ className, style }: Props) {
  const router = useRouter();
  const { busy, withDefaultErrorHandler } = useBusyCount();

  const modalTriggers = {
    ModalPrompt: useModalTrigger$ModalPrompt(),
  };

  return (
    <div className={cx(styles.container, className)} style={style}>
      <ButtonOnNavbar
        size="md-square"
        icon={<MdSearch />}
        title="Search"
        onClick={withDefaultErrorHandler(async () => {
          const searchQuery = await modalTriggers.ModalPrompt.openModal(
            "Search assets & policies",
            {
              validate: (value) => {
                InlineError.assert$PunishBeforeSubmitting(
                  value,
                  "This field is required"
                );
              },
            }
          );
          await router.push(getLinkToPageExploreAssets(searchQuery));
        })}
        disabled={busy}
      />
    </div>
  );
}
